<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
          >
            <el-form-item label="区域" prop="orgName">
              <el-input
                v-model="searchForm.orgName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="cusName">
              <el-input
                v-model="searchForm.cusName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="门店" prop="shopName">
              <el-input
                v-model="searchForm.shopName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="操作人" prop="createName">
              <el-input
                v-model="searchForm.createName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="Openid" prop="openId">
              <el-input
                v-model="searchForm.openId"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动ID" prop="activityId">
              <el-input
                type="number"
                v-model="searchForm.activityId"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sortOrder">
              <el-select v-model="searchForm.sortOrder" size="small" clearable @change="onSearch">
                <el-option v-for="item in sort"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportData">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="activityId" label="活动ID" align="center" width="120"></el-table-column>
          <el-table-column prop="orgName" label="区域"  align="center" width="150"></el-table-column>
          <el-table-column prop="cusName" label="经销商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="shopName" label="门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createName" label="操作人" align="center" width="120"></el-table-column>
          <!-- <el-table-column prop="inCusName" label="微信昵称" align="center" width="150"></el-table-column> -->
          <el-table-column prop="openId" label="OpenID" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="充值类型" align="center" width="130"></el-table-column>
          <el-table-column prop="amount" label="充值金额(元)" align="center"  width="120"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
export default {
  mixins: [tableMixin],
  data() {
    return {
      searchForm: {
        orgName: '',
        cusName: '',
        shopName: '',
        createName: '',
        openId: '',
        activityId: '',
        sortOrder: '',
      },
      sort: [
        {value: '', label: '默认'},
        {value: 1, label: '金额从大到小'},
        {value: 2, label: '金额从小到大'},
      ],
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .queryRechargeList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          this.filterParam.startTime = val[0] || "";
          this.filterParam.endTime = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    exportData() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("queryRechargeList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}

</style>
